import { apiFetch } from "../api";
import { BASE_URL as u } from "../../commonUrls";

const BASE_URL = `${u}/planner/today`;

export const getTodaySummary = async (days = 15) => {
  const res = await apiFetch(`${BASE_URL}?days=${days}`);
  if (!res.ok) return { urgent: [], reminders: [], payments: [] };
  return res.json();
};

export const updatePlannerStatus = async (id, status) => {
  const res = await apiFetch(`${u}/planner/${id}/status`, {
    method: "PATCH",
    body: JSON.stringify({ status }),
  });
  return res.json();
};

// Accurate JPQL-computed counts (overdue/today/thisWeek/upcomingPayments) — used by
// LifePulseGauge instead of re-deriving from the today-summary item lists client-side.
export const getPlannerStats = async () => {
  const res = await apiFetch(`${u}/planner/stats`);
  if (!res.ok) return null;
  return res.json();
};
